import { render, staticRenderFns } from "./GuidedFaceCamera.vue?vue&type=template&id=45681a0a&scoped=true&"
import script from "./GuidedFaceCamera.vue?vue&type=script&lang=js&"
export * from "./GuidedFaceCamera.vue?vue&type=script&lang=js&"
import style0 from "./GuidedFaceCamera.vue?vue&type=style&index=0&id=45681a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45681a0a",
  null
  
)

export default component.exports